import { createProvider } from '@nvision/services/data-provider';

import type { PricingCategoryFilters } from '../../models';
import * as api from './api';
import { normalizePricingCategories, normalizePricingCategoryFilters } from './normalize';

export const fetchPricingCategories = createProvider(
  (filters: Partial<PricingCategoryFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchPricingCategories(normalizePricingCategoryFilters(filters), { signal }),
).andThen((res) => normalizePricingCategories(res));
